var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('video',{ref:"videoPlayer",staticClass:"video-js vjs-default-skin img-fluid",attrs:{"autoplay":_vm.autoplay,"loop":_vm.loop,"playsinline":""},on:{"timeupdate":_vm.updateProgress}},[_c('source',{attrs:{"src":_vm.webmUrl,"type":"video/webm"}}),_c('source',{attrs:{"src":_vm.mp4Url,"type":"video/mp4"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }